import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { useMutation } from '@tanstack/react-query'

const deleteAutoAssign = async (backofficeUserId: string) => {
  const response = await httpClientPrivate.delete(
    `${config.restUrl}/v1/backoffice/pool/health-claim-auto-assignment/${backofficeUserId}`,
  )
  return response.data
}

const useDeleteAutoAssign = (backofficeUserId: string) => {
  const mutation = useMutation({
    mutationKey: ['useDeleteAutoAssign', backofficeUserId],
    mutationFn: async () => deleteAutoAssign(backofficeUserId),
  })

  return mutation
}

export { deleteAutoAssign, useDeleteAutoAssign }
